import { render, staticRenderFns } from "./saoma.vue?vue&type=template&id=cb5ca678&scoped=true"
import script from "./saoma.vue?vue&type=script&lang=js"
export * from "./saoma.vue?vue&type=script&lang=js"
import style0 from "./saoma.vue?vue&type=style&index=0&id=cb5ca678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ca678",
  null
  
)

export default component.exports